import React from 'react';

export default function InteractionFooterButtons({ onGenerate, onCancel, onSave }) {
  return (
    <footer
      className="bg-white border-top p-3"
      style={{ marginLeft: 260 }}
    >
      <div className="d-flex justify-content-between">
        <button
          className="btn btn-outline-secondary"
          onClick={onGenerate}
        >
          Generar informe
        </button>
        <div>
          <button
            className="btn btn-outline-secondary me-2"
            onClick={onCancel}
          >
            Cancelar
          </button>
          <button
            className="btn"
            style={{
              backgroundColor: '#4723C0',
              borderColor: '#2831DD',
              color: '#ffffff'
            }}
            onClick={onSave}
          >
            Confirmar y guardar
          </button>
        </div>
      </div>
    </footer>
  );
}
